import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login.jsx';
import NewLogin from './pages/NewLogin.jsx';
import Register from './pages/Register.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Contacts from './pages/Contacts.jsx';
import Applications from './pages/Applications.jsx';
import Postings from './pages/Postings.jsx';
import Messages from './pages/Messages.jsx';
import Memberslist from './pages/Memberslist.jsx';
import PostedJobs from './pages/PostedJobs.jsx';
import Programslist from './pages/Programslist.jsx';
import Addkse from './pages/Addkse.jsx';
import UnifiedDashboard from './pages/UnifiedDashboard.jsx';
import Blog from './pages/Blog.jsx';
import PostedBlogs from './pages/PostedBlogs.jsx';
import Investors from './pages/Investors.jsx';
import Image from './pages/Image.jsx';
import Postedimages from './pages/Postedimages.jsx';
import Video from './pages/Video.jsx';
import Postedvideos from './pages/Postedvideos.jsx';
import Postedlocs from './pages/Postedlocs.jsx';
import Locations from './pages/Locations.jsx';
import PostedWinners from './pages/PostedWinners.jsx';
import Winners from './pages/Winners.jsx';
import Contactdetails from './pages/Contactdetails.jsx';
import Awards from './pages/Awards.jsx';
import Forgotpassword from './pages/Forgotpassword.jsx';
const App = () => {
  return (
    <Router>
      <Routes>
        
        <Route path="/" element={<Login />} />
        <Route path="/forgotpassword" element={<Forgotpassword />} />
        <Route path="/dashboard" element={<UnifiedDashboard />} />
        
        {/* <Route path="/dashboard/contacts" element={<Contacts />} /> */}
        <Route path="/dashboard/messages" element={<Messages />} />
        <Route path="/dashboard/applications" element={<Applications />} />
        <Route path="/dashboard/postings" element={<PostedJobs />} />
        <Route path="/dashboard/members/addmember" element={<Register />} />
        <Route path="/dashboard/members" element={<Memberslist />} />
        <Route path="/dashboard/postings/postjob" element={<Postings />} />
        <Route path="/dashboard/programs" element={<Programslist />} />
        <Route path="/dashboard/programs/addkse" element={<Addkse />} />
        <Route path="/dashboard/kseapplications" element={<Applications />} />
        <Route path="/dashboard/blogs" element={<PostedBlogs />} />
        <Route path="/dashboard/blogs/addblog" element={<Blog />} />
        <Route path="/dashboard/investors" element={<Investors />} />
        <Route path="/dashboard/images" element={<Postedimages />} />
        <Route path="/dashboard/images/addimage" element={<Image />} />
        <Route path="/dashboard/videos" element={<Postedvideos />} />
        <Route path="/dashboard/videos/addvideo" element={<Video />} />
       <Route path="/dashboard/locations" element={<Postedlocs />} />
      <Route path="/dashboard/locations/addloc" element={<Locations />} />
      <Route path="/dashboard/winners" element={<PostedWinners />} />
      <Route path="/dashboard/winners/addwinner" element={<Winners />} />
      <Route path="/dashboard/contacts" element={<Contactdetails />} />
      <Route path="/dashboard/awards" element={<Awards />} />
      </Routes>
    </Router>
  );
};

export default App;
